import React from 'react';
import L51 from '../images/L51.png';
import '../css/Equipments.css'; // Import your project-specific CSS file for styling
import e1 from '../images/e1.png';
import e2 from '../images/e2.png';
import e5 from '../images/e5.png';
import t1 from '../images/t1.png';
import d1 from '../images/d1.png';
import ul1 from '../images/ul1.png';
import e7 from '../images/e7.png';



import { useState, useEffect } from'react';




const Equipments = () => {
  const colorMapping = {
    '#FF5733': 'Red',
    '#3391FF': 'Blue',
  };

  const colors = Object.keys(colorMapping);
  const [currentColorIndex, setCurrentColorIndex] = useState(0);

  useEffect(() => {
    const textColorChangeInterval = setInterval(() => {
      setCurrentColorIndex((prevIndex) => (prevIndex + 1) % colors.length);
    }, 2000);

    return () => {
      clearInterval(textColorChangeInterval);
    };
  }, []);

  const currentColorCode = colors[currentColorIndex];
  const currentColorName = colorMapping[currentColorCode];
  return (

    <div className="eqp" >
    <h2 style={{ color: currentColorCode }}>Components and Budget</h2>
    <div className="your-project-card">
      <div className="your-project-card-image">
        <img src={e1} alt="Equipment" />
      </div>
      <div className="your-project-card-text">
        <h4>NodeMCU ESP8266</h4>
        <p>NodeMCU is an open-source firmware and development kit for building Internet of Things (IoT) applications. It is based on the ESP8266 Wi-Fi module and comes with a Lua scripting language, which allows developers to write code for connecting the device to the internet and interacting with various sensors and actuators. It is a small, low-cost device with built-in support for Wi-Fi connectivity and several GPIO pins.</p>
        <p> <span> Price : 400 Taka</span></p>
      </div>
    </div>



    <div className="your-project-card">
      <div className="your-project-card-image">
        <img src={e2} alt="Equipment" />
      </div>
      <div className="your-project-card-text">
        <h4>Arduino</h4>
        <p>Arduino is an open-source hardware and software platform designed for easy prototyping of electronic devices. It consists of a microcontroller board and a programming environment that allows users to write, upload, and run code on the board. Arduino is widely used by hobbyists, students, and professionals to build a wide range of projects such as robots, interactive art installations.</p>
        <p> <span> Price : 1075 Taka</span></p>
      </div>
    </div>


    <div className="your-project-card">
      <div className="your-project-card-image">
        <img src={e5} alt="Equipment" />
      </div>
      <div className="your-project-card-text">
        <h4>Temparature and Humidity Sensor</h4>
        <p>A temperature and humidity sensor is a device that measures the temperature and relative humidity of the surrounding air. It consists of a small integrated circuit that contains a temperature sensor and a humidity sensor and is commonly used in weather monitoring, indoor climate control, and other applications where temperature and humidity are important factors.</p>
        <p> <span> Price : 490 Taka</span></p>
      </div>
    </div>


    <div className="your-project-card">
      <div className="your-project-card-image">
        <img src={ul1} alt="Equipment" />
      </div>
      <div className="your-project-card-text">
        <h4>Ultrasonic Sensor</h4>
        <p>An ultrasonic sensor is a device that uses high-frequency sound waves (ultrasonic waves) to detect objects and measure distances. It emits sound waves and measures the time it takes for the waves to bounce back after hitting an object. This information is used to calculate the distance between the sensor and the object.</p>
        <p> <span> Price : 95 Taka</span></p>
      </div>
    </div>


    <div className="your-project-card">
      <div className="your-project-card-image">
        <img src={d1} alt="Equipment" />
      </div>
      <div className="your-project-card-text">
        <h4> LCD Touch Display</h4>
        <p>An LCD touch display combines a visual screen (LCD) with touch-sensitive technology, allowing users to interact directly by tapping, swiping, and more. They are used in devices like smartphones, ATMs, and industrial control panels, offering intuitive interaction. Their durability, resolution, and customization options make them versatile, but they can be susceptible to glare and fingerprints.</p>
        <p> <span> Price : 3600 Taka</span></p>
      </div>
    </div>

    <div className="your-project-card">
      <div className="your-project-card-image">
        <img src={t1} alt="Equipment" />
      </div>
      <div className="your-project-card-text">
        <h4> Touch Sensor</h4>
        <p>A touch sensor is an input device that detects physical touch or contact with a surface, enabling users to interact with various electronic devices. These sensors come in different types, including capacitive, resistive, and infrared, and are commonly used in smartphones, tablets, touchpads, and touchscreens. </p>
        <p> <span> Price : 200 Taka</span></p>
      </div>
    </div>


    <div className="your-project-card">
      <div className="your-project-card-image">
        <img src={e7} alt="Equipment" />
      </div>
      <div className="your-project-card-text">
        <h4> Arduino CMOS Camera Module</h4>
        <p>The Arduino CMOS Camera Module is a small camera module designed to work with Arduino boards. It has a high-resolution CMOS sensor and can capture still images and video. The module is controlled via an I2C interface, making it easy to connect to an Arduino board. It is commonly used in projects such as security systems, surveillance cameras, and image processing applications. The module is easy to use and provides a low-cost solution for adding image capture capabilities to Arduino-based projects. </p>
        <p> <span> Price : 1040 Taka</span></p>
      </div>
    </div>














    <br /><br /> <br />
    </div>
  );
}

export default Equipments;
